import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const AutomationLimitsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-automation-limits-modal" */ './dialog'
			),
		{
			moduleId: 'edition-awareness-automation-limits-modal',
		},
	),
	getPreloadProps: () => ({
		entryPoints: {},
		extraProps: {},
		queries: {},
	}),
});

export default AutomationLimitsEntryPoint;
